/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserInput = {
    /**
     * The first name of the user.
     */
    firstName?: string;
    /**
     * The last name of the user.
     */
    lastName?: string;
    /**
     * The user's gender.
     */
    gender?: string;
    /**
     * The user's age.
     */
    age?: number;
    /**
     * The user's phone number.
     */
    phoneNumber?: string;
    /**
     * Type of the user
     */
    userType?: UserInput.userType;
    /**
     * Further user data.
     */
    data?: string;
    /**
     * Did this user subscribe to newsletters?
     */
    recommendationAndFootwearConsent?: boolean;
    /**
     * Did this user agree to analytics data collection?
     */
    researchAndImprovementsConsent?: boolean;
};
export namespace UserInput {
    /**
     * Type of the user
     */
    export enum userType {
        PATIENT = 'PATIENT',
        OPERATOR = 'OPERATOR',
    }
}

